var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDateTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.652 13.826a4.174 4.174 0 1 0 8.348 0 4.174 4.174 0 0 0-8.348 0z",
    stroke: "#00C8A9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00C8A9",
    d: "M15.217 13.826h-1.39V11.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26 14.521H2.697A.696.696 0 0 1 2 13.825V4.086c0-.384.311-.695.696-.695h12.521c.385 0 .696.311.696.695v4.522M5.478 2v3.478M12.435 2v3.478M2 6.87h13.913",
    stroke: "#202326"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateTime);
export default __webpack_public_path__ + "static/media/iconDateTime.2479fe559bbc410796fcd91f15228211.svg";
export { ForwardRef as ReactComponent };